import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from '../../redux/store/storehooks';
import { getLabProcess } from '../../api/api';
import { errorNotify } from '../../services/toast.notification';
import Spinner from "../../components/_common/Spinner";
import { UpdateProcessList} from '../../redux/reducers/LabProcessSlice';
import './shape.css'
import { Tooltip } from 'antd';
import CustomTooltip from "./CustomTooltip";
import { UpdatePathologyProcessList } from "../../redux/reducers/LabPathologyProcessSlice";


export interface InputProps {
    url: any
  }
  
const LabProcess = ({url}:InputProps) =>{
    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();
    const [isLoading,setIsLoading] = useState(true);
    
    const _getLabProcess = (url:string,optionName:string,wantWebOPtion:boolean,app:Number) => {
        getLabProcess(url,optionName,wantWebOPtion,app)
        .then((result) => {
            dispatch(UpdateProcessList({processList:result?.innerArray}))
            setIsLoading(false);
            console.log(result);
        })
        .catch((error) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })
    }

    const _getPathologyLabProcess = (url:string,optionName:string,wantWebOPtion:boolean,app:Number) => {
      getLabProcess(url,optionName,wantWebOPtion,app)
      .then((result) => {
          dispatch(UpdatePathologyProcessList({pathologyProcessList:result?.innerArray}))
          setIsLoading(false);
          console.log(result);
      })
      .catch((error) => {
        console.log(error);
        errorNotify(error.response.data.errorMessage,undefined,5000)
      })
  }

    useEffect(()=>
    {
        _getLabProcess(url,'LabProcess',false,1);
        _getPathologyLabProcess(url,'pLabProcess',false,2);
    },[]);

    let num = 0;

    return(  
            
        <div className="tab-content-padding">
        {  isLoading === false  && (

            <> 
              <div>
                   <p style={{fontSize:'25px !important',marginBottom:'-10px'}}>بالینی</p>
                {
                        
                        myStore.processList.list.map((process:any) =>{
                            num = num + 1;
                             return (
                              process.length>1 ? 
                              <Tooltip title={<CustomTooltip processes={process} />} color="white">
                                   <button type="button" className="btn btn-primary btn-arrow-right"><span className="button-text">{num}</span>{process[0]}</button>
                              </Tooltip> :
                              <button type="button" className="btn btn-primary btn-arrow-right"><span className="button-text">{num}</span>{process[0]}</button>

                            )
                    })
                } 
              </div>
              <div style={{marginTop:'50px'}}>
                {myStore.pathologyProcessList.list.length>0 && <p style={{fontSize:'25px !important',marginBottom:'-10px'}}>پاتولوژی</p>}
                {
                        
                        myStore.pathologyProcessList.list.map((process:any) =>{
                            num = num + 1;
                             return (
                              process.length>1 ? 
                              <Tooltip title={<CustomTooltip processes={process} />} color="white">
                                   <button type="button" className="btn btn-primary btn-arrow-right"><span className="button-text">{num}</span>{process[0]}</button>
                              </Tooltip> :
                              <button type="button" className="btn btn-primary btn-arrow-right"><span className="button-text">{num}</span>{process[0]}</button>

                            )
                    })
                }
              </div> 
            </>
                      
        
         )
      }
      {
        isLoading === true  && (
        <Spinner />
      )
    }
    </div>
    )


}

export default LabProcess;